import { StateHandlerBase } from './state.handler.base';

export class VisibleStateHandler extends StateHandlerBase {
  public override handle(): void {
    const isVisible: boolean = this.evaluator.evaluate();

    this.element.attributes = {
      ...this.element.attributes,
      hidden: !isVisible,
    };

    if (!this.control) {
      return;
    }

    if (isVisible) {
      this.control.enable();
      this.control.markAsUntouched();
    } else {
      this.control.reset();
      this.control.disable();
    }
  }
}
